import AdultSymptomExercisePage from '@/components/AdultSymptomExercisePage';
import { isAdultExerciseGroup } from '@/lib/data/contentCatalog';
import { useLocaleStore } from '@/lib/stores/localeStore';
import { createFileRoute } from '@tanstack/react-router';
import ExerciseImage from "@/assets/exercise-background-photos/flashbacks.jpg";
import flashbacksVideoMp4 from '@/assets/videos/adults-symptoms/flashbacks/flashbacks.mp4';
import flashbacksVideoWebm from '@/assets/videos/adults-symptoms/flashbacks/flashbacks.webm';
import flashbacksThumbnail from '@/assets/flashback-thumbnail.jpg';
import flashbacksAr from '/subs/flashbacks.ar.vtt';
import flashbacksEn from '/subs/flashbacks.en.vtt';

export const Route = createFileRoute('/(content)/adults/exercises/flashbacks/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    group: isAdultExerciseGroup(search.group) ? search.group : undefined,
    mode: (search.mode === 'videos' || search.mode === 'exercises') ? search.mode as 'videos' | 'exercises' : undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Flashbacks - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "exercises.categories.flashbacks",
    navbar: {
      transparent: true,
      showTitle: false,
    },
  }),
});

function RouteComponent() {
  const { group, mode } = Route.useSearch();
  const navigate = Route.useNavigate();
  const locale = useLocaleStore((state) => state.locale);
  const captionsDir: 'ltr' | 'rtl' = locale === 'ar' ? 'rtl' : 'ltr';

  const videos = [
    {
      sources: [
        { src: flashbacksVideoWebm, type: 'video/webm' },
        { src: flashbacksVideoMp4, type: 'video/mp4' },
      ],
      videoClassName: "w-full h-full object-contain bg-modal",
      subtitleTracks: [
        { src: flashbacksAr, srcLang: 'ar', label: 'Arabic', default: true },
        { src: flashbacksEn, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
  ];

  return (
    <AdultSymptomExercisePage
      symptom="flashbacks"
      titleKey="exercises.categories.flashbacks"
      heroImage={ExerciseImage}
      poster={flashbacksThumbnail}
      videos={videos}
      mode={mode}
      onModeChange={(nextMode) =>
        navigate({
          to: Route.to,
          search: {
            mode: nextMode ?? undefined,
            group: nextMode === 'exercises' ? group : undefined,
          },
        })
      }
      selectedGroup={group}
      onSelectGroup={(nextGroup) =>
        navigate({
          to: Route.to,
          search: { mode: 'exercises', group: nextGroup },
        })
      }
      navButtonColor="text-dark-gray/60"
      skipButtonBgColor="bg-dark-gray/40"
    />
  );
}
